<template>
  <div v-if="isEmptyCalendar">
    <template v-if="isExpress && filterType !== 'telemed'">
      <AppointmentButtonCallLpu
        v-if="isMobile"
        :phone="lpuPhone"
        :lpu-working-text="lpuWorkingText"
      />
    </template>
    <CalendarStub v-else />
  </div>
  <div
    v-else
    :class="isMobile ? 'mx-n4' : 'mr-n6'"
  >
    <AppointmentCalendar
      :is-appointment-doctor="isWorkplace"
      :is-appointment-lpu="!isWorkplace"
      :slots="calendarSlots"
      :padding-left="isMobile ? undefined : 0"
      :padding-right="isMobile ? undefined : 24"
      :fog="isMobile ? false : 'left'"
      :appointment-type="filterType === 'telemed' ? '' : appointmentType"
      :lpu-working-text="lpuWorkingText"
      :lpu-phone="lpuPhone"
      @calendar:time-choice="handleCalendarTimeChoice"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import AppointmentCalendar from 'www/vue_components/common/AppointmentCalendar/AppointmentCalendar.vue'
import CalendarStub from 'www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/components/WorkplaceOrServiceCalendar/components/CalendarStub.vue'
import { useDoctorPageLpuListStore, useExternalDataStore } from 'www/vue_components/common/DoctorPageLpuList/stores'
import { useDoctorAppointmentCardStore } from 'www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/stores'
import AppointmentButtonCallLpu from 'www/vue_components/common/AppointmentButtonCallLpu/AppointmentButtonCallLpu.vue'

const doctorPageLpuListStore = useDoctorPageLpuListStore()
const { filterType } = storeToRefs(doctorPageLpuListStore)

const props = defineProps<{
  lpuId: number
  isWorkplace: boolean
  appointmentType: 'express' | 'direct' | ''
  lpuWorkingText: string
  lpuPhone?: string
}>()

const emit = defineEmits(['calendar-time-choice'])

const externalDataStore = useExternalDataStore()
const { isMobile } = storeToRefs(externalDataStore)

const doctorAppointmentCardStore = useDoctorAppointmentCardStore(props.lpuId)()
const { calendarSlots } = storeToRefs(doctorAppointmentCardStore)

const isEmptyCalendar = computed(() => Object.values(calendarSlots.value).every(times => !times.length))
const isExpress = computed(() => props.appointmentType === 'express')

function handleCalendarTimeChoice({ day, time }: { day: string, time: string }) {
  emit('calendar-time-choice', { day, time })
}
</script>
